import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload/fileupload';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { Status } from '../../../../../app/models/statusEnums';
import { ObjectNoteService } from "../../api/api";
import { NoteAttachment, ObjectNote } from '../../model/models';
import { uploadFiles, validateFiles } from '../../../../../app/shared/upload-files';

@Component({
  selector: 'app-lion-shared-notes',
  templateUrl: './shared-notes.component.html',
  styleUrls: ['./shared-notes.component.scss']
})
export class LionSharedNotesComponent {

  @Input() displayNotesAdd;
  @ViewChild('createNote') createNote: FormGroupDirective;
  @Output() cancelNote: EventEmitter<any> = new EventEmitter();
  notesTemp: ObjectNote = {
    "id": 0,
    "createdSource": this.app.userIP,
    "createdBy": this.app.user.userId,
    "createdDate": new Date(),
    "objectId": 0,
    "objectTypeId": 0,
    "noteId": 0,
    "note": {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "createdDate": new Date(),
      "comment": "",
      "isImportant": false,
      "organizationId":  this.app.user.organizationId,
      "description": "",
      "statusId": Status.Active,
      "isValid": true,
      "validFromDate": null,
      "validToDate": null,
      "noteComments": null,
      "noteAttachments": []
    }
  };
  icon = "fa fa-thumb-tack fa-rotate-90";
  noteAttachment: NoteAttachment = {
    "id": 0,
    "createdSource": this.app.userIP,
    "createdBy": this.app.user.userId,
    "createdDate": new Date(),
    "noteId": 0,
    "attachmentId": 0,
    "attachment": {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "createdDate": new Date(),
      "name": "",
      "guidName": "",
      "location": "",
      "content": "",
      "extension": "",
      "sizeInBytes": 0,
      "description": "",
      "statusId": Status.Active,
      "isValid": true,
      "validFromDate": null,
      "validToDate": null
    }
  };
  multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
      <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
      <li>Files size should not be more than 2MB</li>
    </ul>
  `;
  allowedExtensions = ['.pdf', '.csv', '.txt', '.xlsx', '.xls', '.docx', '.doc', '.png', '.jpg', '.jpeg', '.ppt', '.pptx', '.gif', '.zip']; // For the attachment files
  disabledSubmit = false;
  constructor(private app: AppMainComponent,
    private noteService: ObjectNoteService,
    private appMainService: AppMainService,
    private messageService: MessageService) { }

  cancel() {
    this.createNote.reset();
    this.displayNotesAdd = false;
    this.notesTemp = {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "createdDate": new Date(),
      "objectId": 0,
      "objectTypeId": 0,
      "noteId": 0,
      "note": {
        "id": 0,
        "createdSource": this.app.userIP,
        "createdBy": this.app.user.userId,
        "createdDate": new Date(),
        "comment": "",
        "isImportant": false,
        "organizationId":  this.app.user.organizationId,
        "description": "",
        "statusId": Status.Active,
        "isValid": true,
        "validFromDate": null,
        "validToDate": null,
        "noteComments": null,
        "noteAttachments": []
      }
    };
    this.cancelNote.emit({ "cancelNote": this.displayNotesAdd });
  }

  pin() {
    this.notesTemp.note.isImportant = !this.notesTemp.note.isImportant;
    if (this.notesTemp.note.isImportant) {
      this.icon = "fa fa-thumb-tack";
    } else {
      this.icon = "fa fa-thumb-tack fa-rotate-90";
    }
  }

  uploadAttachments(files: File[], fileUpload: FileUpload) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      let count = 0;
      for (let file of files) {
        let errors = validateFiles(file, 2, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
          }
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            const lastIndex = name.lastIndexOf(".");
            const fileName = name.substring(0, lastIndex);

            this.noteAttachment.attachment = {
              id: 0,
              content,
              name: fileName,
              extension,
              isValid: true,
              sizeInBytes: size,
              statusId: Status.Active,
              createdBy: this.app.user.userId,
              createdDate: new Date(),
              createdSource: this.app.userIP
            };
            this.notesTemp.note.noteAttachments.push(this.app.copyObjectWithoutRefrence(this.noteAttachment));
          });
        }
        count++;
        if (count === files.length) {
          fileUpload.clear();
        }
      }
      this.appMainService.isHideSpinner('upload');
    } else {
      this.appMainService.isHideSpinner('upload');
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }
  }

  // checkValue(evt, element: Editor) {
  //   let value = evt.textValue;
  //   const parentElement = element.el.nativeElement.children[0].children[1];
  //   const firstChild = parentElement.children[0];
  //   if(!value && (value.length === 0)) {
  //     this.renderer.setStyle(firstChild, 'border', '1px solid red');
  //   } else {
  //     this.renderer.setStyle(firstChild, 'border', '');
  //   }
  // }

  addNote() {
    if(this.createNote.form.valid) {
      this.appMainService.isShowSpinner("addNote");
      this.disabledSubmit = true;
      let note = JSON.parse(JSON.stringify(this.notesTemp));
      note.objectId = this.app.objectId;
      note.objectTypeId = this.app.allObjects.filter(elem => elem.name === this.app.objectType)[0].type;
      this.noteService.lionO36020APIObjectNotePost(note).toPromise()
      .then(note => {
        this.disabledSubmit = false;
        this.appMainService.isHideSpinner("addNote");
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note saved successfully...' });
        this.cancel();
        //this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
        this.app.getAllObjects(true, false, false);
        this.createNote.reset();
      }).catch(errResp => {
        this.appMainService.isHideSpinner("addNote");
        this.disabledSubmit = false;

        if(this.notesTemp?.note?.noteAttachments.filter(att=>att?.attachment?.name?.length>50)?.length>0){
            this.messageService.add({ severity: 'error', summary: 'Filename too long', detail: "Maximum 200 characters filename allowed!" });
        }else{
            this.messageService.add({ severity: 'error', summary: 'Error', detail: errResp.error.Message });
        }

      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill out information...' });
    }
  }

  removeAttachment(attachments){
    this.notesTemp.note.noteAttachments = attachments.filter(att=>att?.attachment?.statusId != Status.Deleted);
  }

}
